import React, { useEffect, useState } from "react";
import { Phone, ArrowRight, X } from "lucide-react";
import { FIRM } from "../data/mock";

export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem("bufkin_sticky_dismissed") === "1";
  });

  const handleDismiss = () => {
    setDismissed(true);
    try {
      window.localStorage.setItem("bufkin_sticky_dismissed", "1");
    } catch (e) {
      // localStorage unavailable — fine, in-memory state still works
    }
  };

  useEffect(() => {
    const onScroll = () => {
      const heroHeight = window.innerHeight * 0.85;
      const contactSection = document.getElementById("contact");
      const y = window.scrollY;

      // Hide once the contact section is in the viewport — the form is right there
      const contactInView = contactSection
        ? contactSection.getBoundingClientRect().top < window.innerHeight - 100
        : false;

      setVisible(y > heroHeight && !contactInView);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (dismissed) return null;

  return (
    <div
      data-testid="sticky-cta"
      className={`fixed bottom-0 left-0 right-0 z-40 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="bg-navy border-t-2 border-gold shadow-2xl">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-3 lg:py-4 flex items-center justify-between gap-4">
          {/* Left content */}
          <div className="flex items-center gap-4 lg:gap-6 min-w-0">
            <div className="hidden sm:flex w-10 h-10 rounded-sm bg-gold/15 items-center justify-center flex-shrink-0">
              <Phone className="w-4 h-4 text-gold" strokeWidth={1.5} />
            </div>
            <div className="min-w-0">
              <div className="text-[10px] uppercase tracking-[0.22em] text-gold font-medium">
                Case Review
              </div>
              <div className="font-serif text-base lg:text-lg text-ivory truncate">
                Speak directly with Dick Bufkin.
              </div>
            </div>
          </div>

          {/* Right CTAs */}
          <div className="flex items-center gap-2 lg:gap-3 flex-shrink-0">
            <a
              href={`tel:${FIRM.phone.replace(/[^\d+]/g, "")}`}
              data-testid="sticky-cta-phone"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2.5 text-xs tracking-[0.18em] uppercase font-medium text-ivory border border-ivory/30 hover:border-gold hover:text-gold transition-all"
            >
              <Phone className="w-3.5 h-3.5" strokeWidth={2} />
              {FIRM.phone}
            </a>
            <a
              href="#contact"
              data-testid="sticky-cta-consult"
              className="inline-flex items-center gap-2 px-4 lg:px-5 py-2.5 text-[11px] lg:text-xs tracking-[0.18em] uppercase font-medium bg-gold text-navy-deep hover:bg-gold-light transition-all group"
            >
              <span className="hidden sm:inline">Schedule</span>
              <span className="sm:hidden">Book</span>
              <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
            </a>
            <button
              onClick={handleDismiss}
              data-testid="sticky-cta-close"
              className="w-8 h-8 flex items-center justify-center text-ivory/50 hover:text-ivory transition-colors"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
